type Address = {
  streetName?: string;
  houseNumber?: string;
  apartmentNumber?: string;
  postalCode?: string;
  city?: string;
};

export function formatAddress(a?: Address): string | null {
  if (!a) return null;

  const street = [
    a.streetName,
    a.houseNumber,
    a.apartmentNumber ? `/${a.apartmentNumber}` : "",
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  const city = [a.postalCode, a.city].filter(Boolean).join(" ").trim();

  const full = [street, city].filter(Boolean).join(", ").trim();
  return full || null;
}

export function getLegalFormLabel(value?: string): string | null {
  if (!value) return null;

  const legalForms: Record<string, string> = {
    JDG: "Działalność jednoosobowa (JDG)",
    SC: "Spółka cywilna (s.c.)",
    SPJ: "Spółka jawna (sp.j.)",
    SPP: "Spółka partnerska (sp.p.)",
    SPK: "Spółka komandytowa (sp.k.)",
    SKA: "Spółka komandytowo-akcyjna (S.K.A.)",
    SPZOO: "Spółka z o.o.",
    PSA: "Prosta spółka akcyjna (P.S.A.)",
    SA: "Spółka akcyjna (S.A.)",
    DN: "Działalność nierejestrowana",
  };

  return legalForms[value] || value;
}
